import React from 'react';
import { Link, useParams } from 'react-router-dom';
import ArticleCard from '../components/ArticleCard';
import SectionBlock from '../components/SectionBlock';
import Seo from '../components/Seo';
import { getCategoryBySlug } from '../content/categories';
import { getPostsByCategory, getLatestPosts } from '../content/config';

const CategoryPage = ({ forcedSlug = null }) => {
  const { slug } = useParams();
  const resolvedSlug = forcedSlug || slug;
  const category = getCategoryBySlug(resolvedSlug);
  const posts = getPostsByCategory(resolvedSlug);
  const fallback = getLatestPosts(6);
  const displayPosts = posts.length ? posts : fallback;
  const [hero, ...rest] = displayPosts;

  if (!category) {
    return (
      <div className="mx-auto max-w-4xl px-4 py-16 text-center">
        <Seo title="Categorie introuvable" path={resolvedSlug ? `/categorie/${resolvedSlug}` : '/categorie'} />
        <h1 className="lmd-editorial-title text-4xl font-bold text-slate-900">Categorie introuvable</h1>
        <p className="mt-4 text-slate-600">Cette categorie n'existe pas ou n'est pas encore publiee.</p>
        <Link to="/" className="mt-6 inline-flex rounded-md bg-indigo-600 px-4 py-2 text-white">
          Retour a l'accueil
        </Link>
      </div>
    );
  }

  return (
    <div className="bg-slate-50">
      <Seo
        title={category.label}
        description={category.description}
        path={resolvedSlug === 'a-la-une' ? '/a-la-une' : `/categorie/${resolvedSlug}`}
        image={hero?.cover}
      />
      <div className="mx-auto max-w-[1400px] px-4 py-8">
        <div className="mb-6 border-b border-slate-300 pb-3">
          <p className="lmd-kicker">{category.label}</p>
          <h1 className="lmd-editorial-title text-4xl font-bold text-slate-900">{category.label}</h1>
          <p className="mt-2 text-slate-600">{category.description}</p>
        </div>

        {hero ? <ArticleCard article={hero} variant="hero" /> : null}

        <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-2">
          <SectionBlock title="Derniers articles" articles={rest.slice(0, 4)} dense />
          <SectionBlock title="A lire aussi" articles={fallback.slice(0, 4)} dense />
        </div>
      </div>
    </div>
  );
};

export default CategoryPage;
